import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from 'vue';

export interface Emits {
  (event: 'item-mounted', data: HTMLDivElement): void;
  // eslint-disable-next-line @typescript-eslint/unified-signatures
  (event: 'item-unmounted', data: HTMLDivElement): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutMasonryItem',
  emits: ['item-mounted', 'item-unmounted'],
  setup(__props, { emit }) {



const item = ref<HTMLDivElement | null>(null);

onMounted(() => {
  if (item.value) emit('item-mounted', item.value);
});

onUnmounted(() => {
  if (item.value) emit('item-unmounted', item.value);
});

return { __sfc: true,emit, item }
}

})